import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useUserProfileStats(userId: string | undefined) {
  return useQuery({
    queryKey: ["user-profile-stats", userId],
    enabled: !!userId,
    queryFn: async () => {
      if (!userId) return null;
      const { data, error } = await supabase.rpc("user_profile_stats", { p_user_id: userId });
      if (error) throw error;
      return data?.[0] ?? null;
    },
  });
} 